var $76e282c29f69f381$exports = {};
$76e282c29f69f381$exports = {
    "replaceMessage": `Presu\u{148}te s\xfabor, ktor\xfd chcete nahradi\u{165}`
};


export {$76e282c29f69f381$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
